import mutations from "./mutations.js";
import actions from "./actions.js";
import getters from "./getters.js";

export default {
	state() {
		return {
			userId: null,
			token: null,
			email: null,
			userType: null,
			firstName: null,
			lastName: null,
			number: null,
			league: null,
			leagueId: null,
			divisionId: null,
			division: null,
			team: null,
			teamId: null,
			positions: [],
			usersList: [],
			updateComponent: 0,
			didAutoLogout: false,
		};
	},
	mutations,
	getters,
	actions,
};
